import { apiCall } from "./service";
import {
  URL_CONTACTS,
  URL_SEARCH_CONTACTS,
  URL_LIST_CONTACTS,
  URL_CREATE_CONTACT,
  URL_UPDATE_CONTACT,
} from "./URL";

export const api = {
  getContact(id) {
    return apiCall.get({ url: `${URL_CONTACTS}${id}` });
  },

  getContacts(parentType, parentId) {
    return apiCall.get({ url: `${URL_LIST_CONTACTS(parentType, parentId)}` });
  },

  searchContacts(parentType, parentId, searchTerm) {
    return apiCall.get({
      url: `${URL_SEARCH_CONTACTS(parentType, parentId)}${
        searchTerm && searchTerm
      }`,
    });
  },

  createContact(parentType, parentId, payload) {
    return apiCall.post({
      url: `${URL_CREATE_CONTACT(parentType, parentId)}`,
      params: payload,
    });
  },

  updateContact(payload) {
    return apiCall.put({
      url: `${URL_UPDATE_CONTACT(payload.id)}`,
      params: payload,
    });
  },

  deleteContact(id) {
    return apiCall.delete({ url: `${URL_CONTACTS}${id}` });
  },
};

export default api;
